import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppState } from 'src/app/app.state';
import { VerifySignupService } from 'src/app/verify-signup/verify-signup.service';

export interface DialogData {
  content: string;
  title: string;
}
@Component({
  selector: 'app-activate-modal',
  templateUrl: './activate-modal.component.html',
  styleUrls: ['./activate-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ActivateModalComponent implements OnInit {
  isChatRedirect = false;
  isDashboardRedirect = false;
  constructor(
    private dialogRef: MatDialogRef<ActivateModalComponent>,
    private router: Router,
    private _ngZone: NgZone,
    private appState: AppState,
    private verifyService: VerifySignupService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.isChatRedirect = this.router.url.includes('redirectedFrom=chat');
    this.isDashboardRedirect = this.router.url.includes('dashboard');
  }

  navigateToPage() {
    const redirectTo = this.appState.navigatedFrom;
    this._ngZone.run(() => {
      this.dialogRef.close();
      if (redirectTo && Object.keys(redirectTo).length) {
        this.router.navigate([redirectTo]);
      } else if (this.router.url.includes('redirectedFrom=chat')) {
        this.router.navigate(['/chat']);
        return;
      } else if (this.router.url.includes('dashboard')) {
        return;
      } else {
        this.router.navigate(['workspace']);
      }
    });
  }

  resendVerificationMail() {

    this.verifyService.resendVerificationMail().subscribe((res: any) => {
      this.dialogRef.close();
      this.router.navigate(['workspace']);
      if (res?.statusCode == 200) {
        this.openSnackBar(res.message, 'snackbar-success');
      } else {
        this.openSnackBar('Failed to sent verification mail', 'snackbar-error');
      }
    })


  }
  private openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
